import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HybridAuthProvider } from './contexts/HybridAuthContext'
import { WhitelabelProvider } from './contexts/WhitelabelContext'
import App from './App.tsx'
import './styles/index.css'

// Configure React Query with aggressive caching for progress data
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data considered fresh
      gcTime: 30 * 60 * 1000, // 30 minutes - cache retention (formerly cacheTime)
      refetchOnWindowFocus: false, // Don't refetch when tab regains focus
      refetchOnMount: false, // Don't refetch when component remounts
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <WhitelabelProvider>
      <HybridAuthProvider>
        <App />
      </HybridAuthProvider>
    </WhitelabelProvider>
  </QueryClientProvider>
)